export const getTodaysDate = () => {
    const today = new Date();
    return (today.getFullYear() +
        "-" +
        ("0" + (today.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + today.getDate()).slice(-2));
};
export const getTotalBills = (bills, showInactive) => {
    if (bills) {
        return (bills.length -
            (showInactive ? 0 : bills.filter((bill) => bill.inactive).length));
    }
    return 0;
};
export const fetchJson = async (url, options = {}) => {
    try {
        const response = await fetch(url, Object.assign(Object.assign({}, options), { headers: Object.assign({ "Content-Type": "application/json" }, options.headers) }));
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return await response.json();
    }
    catch (error) {
        throw new Error(`Fetch failed: ${error.message}`);
    }
};
